import React, { useMemo } from 'react'
import { getItem } from '../../utils/storageUtils'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { anchorTagFilter } from '../../utils/htmlTagFilter'
import Button from 'components/Common/Button'
import { BUTTON_VARIANT } from 'utils/constants'
import { isLobbyAllRoute } from 'utils/routes'

export const UserRegisterButton = ({ formik = null, loading, spinner = false, text, clickEvent = null, type = 'submit', disabled = false, hidden = false, className = 'btn-hover-effect', disabledClassName = 'disabled', buttonVariant = BUTTON_VARIANT.PRIMARY }) => {
  if (hidden) return null

  const isDisabled = disabled || loading
  return (
    <div className={`submit-btn mx-2 ${isDisabled ? disabledClassName : ''}`}>
      <Button
        variant={buttonVariant}
        type={type}
        disabled={disabled}
        className={`${className}`}
        hidden={hidden}
        onClick={clickEvent || formik.handleSubmit}
        loading={loading}
      >
        {text}
      </Button>
    </div>
  )
}

export const BannerButton = ({ bannerloggedOutBtn, bannerloggedInBtn, pageType, setSelectedFilter = () => {} }) => {
  const navigate = useNavigate()
  const { userDetails } = useSelector(state => state.user)
  const { languageData, selectedLanguageCode } = useSelector(state => state.language)
  const casinoCategories = useSelector(state => state?.casinoMenu?.gameCategory?.casinoCategories)

  const { href, value } = anchorTagFilter(userDetails ? bannerloggedInBtn : bannerloggedOutBtn)

  const generateUpdatedHref = () => {
    const languageCode = selectedLanguageCode?.toLowerCase() ||
      getItem('language')?.toLowerCase() || 'en'

    return href?.split('/')?.[1]?.length !== 2
      ? `/${languageCode}${href}`
      : href?.replace(href?.split('/')?.[1], languageCode)
  }

  const renderBannerButton = useMemo(() => {
    // const label = getLabel()
    const updatedHref = href ? generateUpdatedHref(href) : ''
    // Target without the language prefix, e.g. /en/casino/all -> /casino/all
    const targetPath = `/${updatedHref.split('/').slice(2).join('/')}`

    const handleClick = () => {
      // Casino lobby "all" target: reset the shared casino filter before navigating,
      // same as the header casino link (HeaderV2) and the mobile bottom menu — a stale
      // sub-category (e.g. auto-selected on the home page) otherwise fights the /all
      // URL in useFilterGames and loops the games API.
      // TODO: remove once casino filter state is derived from the URL instead of
      // shared via Layout, so navigation entry points no longer need to know about it.
      if (isLobbyAllRoute(targetPath, casinoCategories)) {
        setSelectedFilter(selectedFilter => ({ ...selectedFilter, pageNo: 1, subCategoryId: null, category: null }))
      }
      navigate(updatedHref)
    }

    return (
      <Button
        variant={BUTTON_VARIANT.BANNER}
        onClick={handleClick}
      >
        {value}
      </Button>
    )
  }, [pageType, languageData, userDetails, casinoCategories, setSelectedFilter])

  return (
    <div className='banner-join-button'>
      {renderBannerButton}
    </div>
  )
}
